var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSection1Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1611 0H5.13885C2.30074 0 0 2.30074 0 5.13885V21.1976C0 24.0357 2.30074 26.3364 5.13885 26.3364H22.1611C24.9993 26.3364 27.3 24.0357 27.3 21.1976V5.13885C27.3 2.30074 24.9993 0 22.1611 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1144 2.56964H5.13966C3.72065 2.56964 2.57031 3.71998 2.57031 5.13899V20.9905C2.57031 22.4096 3.72065 23.5599 5.13966 23.5599H22.1144C23.5334 23.5599 24.6838 22.4096 24.6838 20.9905V5.13899C24.6838 3.71998 23.5334 2.56964 22.1144 2.56964Z",
    fill: "#D2FA52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8945 4.50183H10.864C10.8003 4.50183 10.7372 4.51438 10.6783 4.53877C10.6195 4.56316 10.566 4.59891 10.5209 4.64397C10.4759 4.68903 10.4402 4.74252 10.4158 4.8014C10.3914 4.86027 10.3789 4.92336 10.3789 4.98708V16.5071C10.3789 16.6357 10.43 16.7591 10.521 16.8501C10.612 16.9411 10.7354 16.9922 10.864 16.9922H22.8945C23.0231 16.9922 23.1465 16.9411 23.2375 16.8501C23.3284 16.7591 23.3796 16.6357 23.3796 16.5071V4.98708C23.3796 4.92336 23.367 4.86027 23.3427 4.8014C23.3183 4.74252 23.2826 4.68903 23.2375 4.64397C23.1925 4.59891 23.139 4.56316 23.0801 4.53877C23.0213 4.51438 22.9582 4.50183 22.8945 4.50183Z",
    fill: "#14AA40",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8989 4.50183H15.8594V16.5506H17.8989V4.50183Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4145 3.99121H10.8008V16.5503H16.4145V3.99121ZM22.9587 3.99121H17.345V16.5503H22.9587V3.99121Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4145 3.99121H10.8008V8.65831H16.4145V3.99121Z",
    fill: "#D2FA52",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8595 6.19663C15.8627 5.92831 15.9716 5.67209 16.1625 5.4835C16.3534 5.29491 16.6109 5.18915 16.8792 5.18915C17.1476 5.18915 17.4051 5.29491 17.596 5.4835C17.7869 5.67209 17.8957 5.92831 17.899 6.19663M15.8595 10.4911C15.8578 10.3562 15.883 10.2222 15.9335 10.0971C15.984 9.97191 16.0589 9.85802 16.1537 9.762C16.2486 9.66599 16.3616 9.58976 16.4861 9.53773C16.6106 9.4857 16.7443 9.45891 16.8792 9.45891C17.0142 9.45891 17.1478 9.4857 17.2724 9.53773C17.3969 9.58976 17.5099 9.66599 17.6047 9.762C17.6996 9.85802 17.7744 9.97191 17.825 10.0971C17.8755 10.2222 17.9006 10.3562 17.899 10.4911M15.8595 14.7856C15.8578 14.6507 15.883 14.5167 15.9335 14.3916C15.984 14.2664 16.0589 14.1525 16.1537 14.0565C16.2486 13.9605 16.3616 13.8843 16.4861 13.8322C16.6106 13.7802 16.7443 13.7534 16.8792 13.7534C17.0142 13.7534 17.1478 13.7802 17.2724 13.8322C17.3969 13.8843 17.5099 13.9605 17.6047 14.0565C17.6996 14.1525 17.7744 14.2664 17.825 14.3916C17.8755 14.5167 17.9006 14.6507 17.899 14.7856",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8792 15.6189C17.0026 15.6189 17.1209 15.668 17.2081 15.7552C17.2954 15.8424 17.3444 15.9607 17.3445 16.084V16.5493H16.4141V16.084C16.4141 15.9607 16.4631 15.8424 16.5503 15.7552C16.6376 15.668 16.7559 15.6189 16.8792 15.6189Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5997 10.4022H14.659M11.6016 11.396H15.0946M11.6016 12.3908H14.4675M11.6016 13.3844H12.6001M19.6122 5.92456H21.5862M18.5281 6.91951H22.0213M18.5281 7.91311H20.5413M19.6122 10.4022H22.0216M18.5281 11.396H21.0369M18.5281 12.3908H21.5857M18.5281 13.3844H20.151M15.7336 16.551V16.9925M18.0247 16.551V16.9925",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87906 9.11877V20.1255C3.87906 21.2266 4.77186 22.1194 5.87301 22.1194C6.97431 22.1194 7.86711 21.2266 7.86711 20.1255H9.10866V9.11877H3.87906Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44141 13.3179H8.50611M4.44141 11.3959H8.50611",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0082 18.1331C8.1079 18.1331 8.0698 19.0145 7.867 20.127C7.6453 21.3429 6.97435 22.121 5.87305 22.121H11.821V18.1331H9.0082Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2376 18.1331H9.00781C9.26123 18.1331 9.50426 18.2337 9.68345 18.4129C9.86264 18.5921 9.96331 18.8351 9.96331 19.0886V21.278C9.96331 21.5016 10.0521 21.716 10.2102 21.8741C10.3684 22.0322 10.5828 22.121 10.8064 22.121C11.03 22.121 11.2444 22.0322 11.4025 21.8741C11.5606 21.716 11.6495 21.5016 11.6495 21.278H15.1929V19.0887C15.1929 18.9632 15.1682 18.839 15.1202 18.723C15.0722 18.6071 15.0018 18.5017 14.9131 18.413C14.8244 18.3242 14.719 18.2538 14.6031 18.2058C14.4872 18.1578 14.3631 18.1331 14.2376 18.1331Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6496 19.503V21.2764C11.6496 21.5 11.5608 21.7144 11.4027 21.8725C11.2446 22.0306 11.0302 22.1194 10.8066 22.1194H16.0364C16.26 22.1194 16.4744 22.0306 16.6325 21.8725C16.7906 21.7144 16.8794 21.5 16.8794 21.2764V19.503H11.6496Z",
    fill: "white",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91361 14.7865L7.28516 12.1581L8.40461 11.0388L9.91361 12.5479L13.2112 9.25049L14.3304 10.3698L9.91361 14.7865Z",
    fill: "#D0EED8",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44141 14.3491H8.50611M8.50581 15.4432H7.74591M6.23556 15.4432H4.44156M8.50581 16.4682H7.74591M6.23556 16.4682H4.44156M8.50581 17.5146H7.74591M14.471 18.8167H13.7111M6.23556 17.5146H4.44156M6.23556 18.5232H4.44156M6.23556 19.5682H4.44156M12.4064 18.8167H10.6123M6.29301 20.5959H4.49901",
    stroke: "#003512",
    strokeWidth: 0.17205,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSection1Icon);
export default __webpack_public_path__ + "static/media/HomeSection1Icon.0d2099febec1a4a4b5846ca7cd973aef.svg";
export { ForwardRef as ReactComponent };